import React from 'react';
import Config from '../../libraries/ReactNativeConfig';
import { View, Text } from 'react-native';
import VersionNumber from '../../libraries/ReactNativeVersionNumber';
import colors from '../../theme/Colors';
import { isWeb } from '../../utils/BooleanUtility';
import { jsonParser } from '../../utils/JsonUtility';
import RemoteConfig from '../../utils/RemoteConfig';
import { REMOTE_CONFIG_KEYS } from '../../config/Constants';

const BuildNumber = () => {
  const { show_power_by_ekstore: hideCredits = true } = jsonParser(
    RemoteConfig.getValue(REMOTE_CONFIG_KEYS.ekstore_credit_footer),
  );
  return (
    <View style={styles.container}>
      <Text style={styles.buildNumberText}>
        {isWeb()
          ? `${Config.APP_NAME}`
          : `${Config.APP_NAME} ${VersionNumber.appVersion} (${VersionNumber.buildVersion})`}
      </Text>
      {!hideCredits && <Text style={styles.bottomText}>Made with love in India </Text>}
    </View>
  );
};

// Styles (you might want to move these to a separate styles file)
const styles = {
  buildNumberText: {
    color: colors.contentPageSeparatorColor,
    fontFamily: 'Roboto-Regular',
    fontSize: 11,
    paddingBottom: 4,
  },
  bottomText: {
    color: colors.disabled,
    fontFamily: 'Roboto-Regular',
    fontSize: 10,
    paddingBottom: 4,
  },
  container: { width: '100%', alignItems: 'center', marginVertical: 24 },
};

export default BuildNumber;
